function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFoodAndDrink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.734,8.564L22.734,3.371L13.952,0.158C13.202,-0.118 12.372,0.218 12.01,0.929L6.395,12.06C4.368,16.075 5.869,20.867 9.562,23.079L7.718,28.174L3.782,26.726C2.966,26.43 2.064,26.851 1.761,27.674C1.458,28.497 1.886,29.405 2.702,29.701L13.538,33.671C14.354,33.967 15.256,33.546 15.552,32.723C15.848,31.9 15.427,30.992 14.61,30.695L10.667,29.254L12.511,24.165C16.993,24.929 21.443,22.006 22.391,17.346L22.727,15.713L23.063,17.346C24.017,22.006 28.46,24.929 32.943,24.165L34.786,29.254L30.843,30.695C30.027,30.992 29.606,31.9 29.902,32.723C30.198,33.546 31.1,33.967 31.916,33.671L42.751,29.701C43.568,29.405 43.989,28.497 43.693,27.674C43.397,26.851 42.495,26.43 41.678,26.726L37.735,28.168L35.892,23.073C39.585,20.861 41.079,16.069 39.059,12.053L33.457,0.929C33.095,0.211 32.259,-0.118 31.515,0.158L22.734,3.371L22.734,8.564ZM20.384,11.487L11.8,8.341L14.189,3.608L21.456,6.267L20.39,11.487L20.384,11.487ZM25.077,11.487L24.011,6.267L31.278,3.608L33.667,8.341L25.084,11.487L25.077,11.487Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFoodAndDrink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/food-and-drink.b51bd4344604b94bbe997f94052e8848.svg";